import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { persistStore, persistReducer } from "redux-persist"
import { userReducer } from "./modules/userSlice"
import { snackbarReducer } from "./modules/snackbarSlice"
import { securePersistStorage } from "../utils/secureStorage"

import thunk from "redux-thunk"

const reducers = combineReducers({
  user: userReducer,
  snackbar: snackbarReducer
})

const persistConfig = {
  key: "root",
  storage: securePersistStorage,
}

const persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

export const persistor = persistStore(store)
